import {parsePatch, type StructuredPatch} from 'diff';
import {useMemo} from 'react';

type UseParsePatchHook =
  | [StructuredPatch[], null]
  | [null, Error]
  | [null, null];

/**
 * Parses a unified diff string into an array of `StructuredPatch` objects.
 *
 * @param content - The raw unified diff text, or `null` if not yet loaded.
 * @returns The parsed patches, or `null` if `content` is falsy or parsing fails.
 */
export function useParsePatch(content: string | null): UseParsePatchHook {
  return useMemo(() => {
    if (!content) {
      return [null, null];
    }
    try {
      return [parsePatch(content), null];
    } catch (e) {
      return [null, e as Error];
    }
  }, [content]);
}
